import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const rundeck = defineConnector({
  identifier: "rundeck",
  name: "Rundeck",
  tagLine: "Runbook automation platform",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "X-Rundeck-Auth-Token",
        value: app.secret.apiToken,
      },
    ]),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Rundeck instance and navigate to **User Profile > User API Tokens** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your Rundeck details",
      items: [
        {
          kind: "baseUrl",
          label: "Rundeck server URL",
          required: true,
          placeholder: "https://rundeck.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Rundeck server.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/41/system/info`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    RUNDECK_URL: baseUrl || "",
  }),
});
